module.exports = __webpack_public_path__ + "img/file-richtext.0e806408.svg";